import Image from '@tiptap/extension-image'

// Extends Image with a single `style` attribute so inline width + float are
// saved into the HTML. Resize is handled by a custom DOM drag handle (see
// RichTextEditor.jsx). Size presets are offered via TipTap BubbleMenu.
// No ReactNodeViewRenderer — it is silently dropped by TipTap v3 when the
// extension is configured with .configure() at the call site.
export const ResizableImage = Image.extend({
  name: 'image',

  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
        parseHTML: (el) => el.getAttribute('style') || null,
        renderHTML: (attrs) => (attrs.style ? { style: attrs.style } : {}),
      },
    }
  },
})
